"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const Viewer_1 = __importDefault(require("~/components/Cad3d/Viewer"));
const UI_1 = require("~/components/UI");
const assets_1 = require("~/assets");
const utils_1 = require("~/components/Cad3d/utils");
const actions_1 = require("~/store/actions");
const consts_1 = require("~/store/consts");
const selectors_1 = require("~/store/selectors");
const events_1 = require("~/utils/events");
const utils_2 = require("~/utils/utils");
const catalogUtils_1 = __importDefault(require("~/utils/catalogUtils"));
const roundNumberWithDecimals_1 = __importDefault(require("~/utils/roundNumberWithDecimals"));
const types_1 = require("~/store/types");
const consts_2 = require("~/components/Cad3d/consts");
const useProjectStatus_1 = __importDefault(require("~/hooks/useProjectStatus"));
const lodash_1 = require("lodash");
const typeUtils_1 = require("~/components/Cad3d/utils/typeUtils");
const BOMItemNotes_1 = __importDefault(require("../BOMItemNotes"));
const BOMItemServices_1 = __importDefault(require("../BOMItemServices"));
const BOMItemPrice_1 = __importDefault(require("../BOMItemPrice"));
const PriceTooltip_1 = __importDefault(require("../PriceTooltip"));
const BOMItem_scss_1 = __importDefault(require("./BOMItem.scss"));
const BOMItemNotesButton_1 = __importDefault(require("../BOMItemNotesButton"));
let tempSizeForComparison = '';
function BOMItem({ item, sizePrecision, forceExpand = false, lineItemNumber }) {
    var _a, _b, _c, _d;
    const { t } = (0, react_i18next_1.useTranslation)('widgets');
    const { t: notifications } = (0, react_i18next_1.useTranslation)('notifications');
    const selectedObjectsUUIDs = (0, react_redux_1.useSelector)(selectors_1.selectSelectedObjectsUUIDs);
    const selectedTool = (0, react_redux_1.useSelector)(selectors_1.selectSelectedTool);
    const selectedItem = (0, react_redux_1.useSelector)(selectors_1.selectSelectedItem);
    const isBOMEditMode = (0, react_redux_1.useSelector)(selectors_1.selectBOMEditMode);
    const isBOMLoading = (0, react_redux_1.useSelector)(selectors_1.selectBOMLoading) === types_1.LOADING_STATE.LOADING;
    const manuallyAddedItems = (0, react_redux_1.useSelector)(selectors_1.selectManuallyAddedItems);
    const quantityInputRef = (0, react_1.useRef)(null);
    const quantityForComparisonRef = (0, react_1.useRef)(item.quantity);
    const sizeInputRef = (0, react_1.useRef)(null);
    const { isOrderCompleted, isProjectArchived, isProjectViewOnly } = (0, useProjectStatus_1.default)();
    const isDefaultFastenersWidgetShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_1.WIDGETS.DEFAULT_FASTENER_WIDGET));
    const isItemReplacementWidgetShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_1.WIDGETS.ITEM_REPLACEMENT_WIDGET));
    const [step, setStep] = (0, react_1.useState)(consts_2.consts.DEFAULT_EXTRUDE_STEP);
    const [min, setMin] = (0, react_1.useState)(1);
    const { dispatchDeleteManuallyAdded, dispatchAddManuallyDeleted, dispatchSelectTool, dispatchAddMachiningServiceManually, dispatchSetBOMLoading, } = (0, redux_1.bindActionCreators)({
        dispatchDeleteManuallyAdded: actions_1.deleteManuallyAdded,
        dispatchAddManuallyDeleted: actions_1.addManuallyDeleted,
        dispatchSelectTool: actions_1.selectTool,
        dispatchAddMachiningServiceManually: actions_1.applyMachiningServiceManually,
        dispatchSetBOMLoading: actions_1.setBOMLoading,
    }, (0, react_redux_1.useDispatch)());
    const isFastener = item.componentType !== null && ((_a = item.componentType) === null || _a === void 0 ? void 0 : _a.name) === types_1.COMPONENT_TYPE.FASTENER;
    const isItemSelectable = selectedTool !== consts_1.TOOL_STATE.SHOW_FASTENERS &&
        !isFastener &&
        ((_b = item === null || item === void 0 ? void 0 : item.uuid) === null || _b === void 0 ? void 0 : _b.some((uuid) => uuid !== '')) &&
        (item === null || item === void 0 ? void 0 : item.uuid.every((uuid) => {
            const obj = utils_1.Utils.getObjectByUUID(Viewer_1.default.instance.getScene(), uuid);
            // Check if object is a fastener
            return (obj === null || obj === void 0 ? void 0 : obj.name[0]) !== 's' && (obj === null || obj === void 0 ? void 0 : obj.name[0]) !== 'f';
        }));
    const isCurrentItemSelected = isItemSelectable && !!((_c = item.uuid) === null || _c === void 0 ? void 0 : _c.some((uuid) => selectedObjectsUUIDs.includes(uuid)));
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(forceExpand);
    const [isDescriptionOverflowing, setDescriptionOverflowing] = (0, react_1.useState)(false);
    const [isSizeOverflowing, setSizeOverflowing] = (0, react_1.useState)(false);
    const [isAddingMsApplicable, setIsAddingMsApplicable] = (0, react_1.useState)(false);
    const BOMWidgetState = (0, react_redux_1.useSelector)((0, selectors_1.selectWidgetState)(consts_1.WIDGETS.BOM_WIDGET));
    const [showNotes, setShowNotes] = (0, react_1.useState)(false);
    const [notesWidgetY, setNotesWidgetY] = (0, react_1.useState)(0);
    const openNotesMenu = (event) => {
        if (!showNotes) {
            setShowNotes(true);
            setNotesWidgetY(event.clientY - BOMWidgetState.position.y);
        }
    };
    const isImperialMeasurement = (0, react_redux_1.useSelector)(selectors_1.selectIsImperialMeasurementUsed);
    const { size, unitOfMeasurement } = (0, react_1.useMemo)(() => {
        var _a;
        return isImperialMeasurement
            ? item
            : (0, utils_2.convertToSI)({
                size: item.size,
                price: item.price,
                unitOfMeasurement: (_a = item.unitOfMeasurement) !== null && _a !== void 0 ? _a : '',
            });
    }, [item, isImperialMeasurement]);
    (0, react_1.useEffect)(() => {
        if (isImperialMeasurement) {
            setStep(consts_2.consts.DEFAULT_EXTRUDE_STEP);
            setMin(1);
        }
        else {
            setStep(consts_2.consts.DEFAULT_EXTRUDE_STEP_MM);
            setMin(1 * consts_2.consts.INCH_TO_MM);
        }
    }, [isImperialMeasurement]);
    const sizeString = (0, react_1.useMemo)(() => (0, roundNumberWithDecimals_1.default)(size !== null && size !== void 0 ? size : 0, sizePrecision).toFixed(sizePrecision), [size, sizePrecision]);
    (0, react_1.useEffect)(() => {
        if (forceExpand) {
            setIsExpanded(true);
        }
    }, [forceExpand]);
    const clickExpandHandler = () => setIsExpanded((current) => !current);
    const onSelectIconClicked = () => __awaiter(this, void 0, void 0, function* () {
        if (isDefaultFastenersWidgetShown) {
            (0, events_1.showNotification)({
                message: notifications('fastener-not-selected-warning'),
                type: 'warning',
            });
            return;
        }
        if (isItemReplacementWidgetShown) {
            (0, events_1.showNotification)({
                message: notifications('item-replacement-not-closed-warning'),
                type: 'warning',
            });
            return;
        }
        yield Promise.all([dispatchSelectTool(consts_1.TOOL_STATE.NAVIGATE)]).then(() => {
            var _a, _b, _c;
            if (isCurrentItemSelected) {
                (_a = item.uuid) === null || _a === void 0 ? void 0 : _a.forEach((uuid) => {
                    Viewer_1.default.instance
                        .getDesignProMain()
                        .selectionTool.unselectObject(utils_1.Utils.getObjectByUUID(Viewer_1.default.instance.getScene(), uuid));
                });
            }
            else {
                const objectsToSelect = (_c = (_b = item.uuid) === null || _b === void 0 ? void 0 : _b.map((uuid) => utils_1.Utils.getObjectByUUID(Viewer_1.default.instance.getScene(), uuid))) !== null && _c !== void 0 ? _c : [];
                Viewer_1.default.instance.getDesignProMain().selectionTool.selectObjects(objectsToSelect);
            }
            Viewer_1.default.instance.maybeZoomToFitSelectedObjects();
        });
    });
    (0, react_1.useEffect)(() => {
        quantityForComparisonRef.current = item.quantity;
    }, [item.quantity]);
    const changeQuantityHandler = (value) => {
        var _a;
        let newValue = Number.parseInt(value, 10);
        newValue = Math.min(Math.max(newValue, 1), 999999);
        (_a = quantityInputRef.current) === null || _a === void 0 ? void 0 : _a.setValue(newValue.toString());
        if (quantityForComparisonRef.current === newValue) {
            return;
        }
        quantityForComparisonRef.current = newValue;
        document.body.dispatchEvent((0, events_1.updateItemsToBOMEvent)([
            {
                itemNumber: item.item_number,
                quantity: newValue,
                uuid: item.uuid[0],
                actionType: types_1.ACTION_TYPE.UPDATE,
                connections: [],
            },
        ]));
    };
    const updateSize = (newSize) => {
        document.body.dispatchEvent((0, events_1.updateItemsToBOMEvent)([
            {
                itemNumber: item.item_number,
                size: newSize,
                uuid: item.uuid[0],
                actionType: types_1.ACTION_TYPE.UPDATE,
                connections: [],
            },
        ]));
    };
    const isValueManuallyEntered = (value) => {
        return !(Number(tempSizeForComparison) + step === Number(value) || Number(tempSizeForComparison) - step === Number(value));
    };
    const debouncedUpdateSize = (0, lodash_1.debounce)((newSize) => {
        updateSize(newSize);
    }, 1500);
    const changeSizeHandler = (value) => {
        const parsedValue = (0, utils_2.roundToDecimals)(Number.parseFloat(value), 3);
        const sizeValue = isImperialMeasurement ? parsedValue : parsedValue / consts_2.consts.INCH_TO_MM;
        if (tempSizeForComparison !== value) {
            if (!isValueManuallyEntered(value)) {
                tempSizeForComparison = value;
                debouncedUpdateSize(sizeValue);
            }
            else {
                updateSize(sizeValue);
            }
            tempSizeForComparison = value;
        }
    };
    const updateNotesHandler = (notes) => {
        if (item.uuid) {
            item.uuid.forEach((id) => {
                document.body.dispatchEvent((0, events_1.updateItemsToBOMEvent)([
                    {
                        itemNumber: item.item_number,
                        uuid: id,
                        actionType: types_1.ACTION_TYPE.UPDATE,
                        manuallyAdded: true,
                        notes,
                    },
                ]));
            });
        }
    };
    const handleDelete = (bomItem) => {
        var _a, _b;
        document.body.dispatchEvent((0, events_1.removeItemsFromBOMEvent)([
            {
                actionType: types_1.ACTION_TYPE.REMOVE,
                manuallyAdded: true,
                itemNumber: bomItem.item_number,
                size: bomItem.size,
                quantity: bomItem.quantity,
                uuid: bomItem.uuid[0],
            },
        ]));
        const key = (_b = (_a = bomItem.uuid) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : bomItem.item_number;
        if (key in manuallyAddedItems) {
            dispatchDeleteManuallyAdded(key);
        }
        else {
            dispatchAddManuallyDeleted(bomItem);
        }
    };
    const clickApplyMSHandler = () => __awaiter(this, void 0, void 0, function* () {
        var _e;
        try {
            if (selectedItem && !(0, utils_2.isICatalogItem)(selectedItem) && ((_e = item.uuid) === null || _e === void 0 ? void 0 : _e[0])) {
                document.body.dispatchEvent((0, events_1.addServicesToBOMEvent)([
                    {
                        projectItemUUID: item.uuid[0],
                        machiningServiceId: selectedItem.id,
                    },
                ]));
                dispatchAddMachiningServiceManually({
                    projectItemUUID: item.uuid[0],
                    machiningServiceId: selectedItem.id,
                });
                dispatchSetBOMLoading();
                if (!isExpanded) {
                    setIsExpanded(true);
                }
            }
        }
        catch (error) {
            (0, events_1.showNotification)({
                message: (0, utils_2.errorify)(error),
                type: 'error',
            });
        }
    });
    (0, react_1.useEffect)(() => {
        if (isBOMEditMode && item.manuallyAdded && selectedItem && !(0, utils_2.isICatalogItem)(selectedItem)) {
            setIsAddingMsApplicable((0, catalogUtils_1.default)(selectedItem, item));
        }
        else {
            setIsAddingMsApplicable(false);
        }
    }, [selectedItem, isBOMEditMode, item]);
    const expandOrActionButton = () => {
        if (isAddingMsApplicable) {
            return (react_1.default.createElement("div", { className: BOMItem_scss_1.default.arrow },
                react_1.default.createElement("img", { src: assets_1.svgApplyMachiningService, onClick: clickApplyMSHandler, alt: "apply machining service" })));
        }
        return (react_1.default.createElement("div", { className: isExpanded ? `${BOMItem_scss_1.default.arrow} ${BOMItem_scss_1.default.expanded}` : BOMItem_scss_1.default.arrow }, item.services && item.services.length > 0 && (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
        react_1.default.createElement("img", { src: assets_1.svgSystemChevronRight, onClick: clickExpandHandler, alt: "chevron right " }))));
    };
    const translatedUnitOfMeasurement = t(`item.unit-of-measurement.${unitOfMeasurement}`);
    const fullSizeText = size ? `${sizeString}${translatedUnitOfMeasurement}` : '-';
    const itemSize = item.size || 0;
    tempSizeForComparison = (0, utils_2.roundWithoutTrailingZeros)(isImperialMeasurement ? itemSize : itemSize * consts_2.consts.INCH_TO_MM, 3);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { "data-testid": "bom-item", "data-active": isCurrentItemSelected, className: `${BOMItem_scss_1.default.item} ${isCurrentItemSelected ? BOMItem_scss_1.default.selected : ''} ${isItemSelectable || item.manuallyAdded ? BOMItem_scss_1.default.selectable : ''}` },
            expandOrActionButton(),
            react_1.default.createElement("div", { className: BOMItem_scss_1.default.itemLineItem }, lineItemNumber),
            react_1.default.createElement("div", { className: BOMItem_scss_1.default.itemImg },
                react_1.default.createElement(UI_1.Image, { src: (0, utils_2.formatAssetsURL)((_d = item.image) === null || _d === void 0 ? void 0 : _d.url) }),
                item.manuallyAdded && isBOMEditMode && (
                // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
                react_1.default.createElement("div", { style: { cursor: 'pointer' }, className: BOMItem_scss_1.default.trashImg, onClick: () => handleDelete(item) },
                    react_1.default.createElement("img", { src: assets_1.svgBasicTrashIcon, alt: "Icon trash" }))),
                !item.manuallyAdded && (react_1.default.createElement("div", null,
                    react_1.default.createElement(UI_1.ToolButton, { onClick: onSelectIconClicked, active: isCurrentItemSelected, icon: assets_1.svgCameraSelectToFit, minSize: "32px" })))),
            react_1.default.createElement("div", { className: BOMItem_scss_1.default.itemNumber }, `#${item.item_number}`),
            react_1.default.createElement("div", { className: BOMItem_scss_1.default.itemDescription, onMouseOver: (e) => setDescriptionOverflowing((0, utils_2.isEventTargetOverflowing)(e)), onFocus: (e) => setDescriptionOverflowing((0, utils_2.isEventTargetOverflowing)(e)) },
                react_1.default.createElement(UI_1.Tooltip, { placement: "right-end", contentNode: react_1.default.createElement("div", { className: BOMItem_scss_1.default.tooltip }, item.description), disabled: !isDescriptionOverflowing },
                    react_1.default.createElement("div", { className: BOMItem_scss_1.default.itemTextWithEllipsis }, item.description))),
            item.manuallyAdded && isBOMEditMode && (0, utils_2.isSizeChangable)(item) && item.size ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: BOMItem_scss_1.default.marginLeft },
                    react_1.default.createElement(UI_1.Input, { type: "number", value: (0, utils_2.roundWithoutTrailingZeros)(isImperialMeasurement ? item.size : item.size * consts_2.consts.INCH_TO_MM, 3), onChange: (value) => changeSizeHandler(value), onBlur: (value) => changeSizeHandler(value), step: step, min: min, max: isImperialMeasurement
                            ? item.stockLength || item.size
                            : Number(item.stockLength) * consts_2.consts.INCH_TO_MM || item.size * consts_2.consts.INCH_TO_MM, precision: 3, defaultKey: true, arrows: !isOrderCompleted && !isProjectArchived && !isProjectViewOnly, disabled: isOrderCompleted || isProjectArchived || isProjectViewOnly, ref: sizeInputRef })),
                react_1.default.createElement("div", { className: BOMItem_scss_1.default.subtitle }, unitOfMeasurement))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: BOMItem_scss_1.default.itemSize, onMouseOver: (e) => setSizeOverflowing((0, utils_2.isEventTargetOverflowing)(e)) },
                    react_1.default.createElement(UI_1.Tooltip, { placement: "right-end", contentNode: react_1.default.createElement("div", { className: BOMItem_scss_1.default.tooltip }, fullSizeText), disabled: !isSizeOverflowing },
                        react_1.default.createElement("div", { className: BOMItem_scss_1.default.itemTextWithEllipsis }, fullSizeText))))),
            item.manuallyAdded && isBOMEditMode && (react_1.default.createElement(UI_1.Input, { type: "number", className: BOMItem_scss_1.default.itemInputNumber, value: item.quantity, onChange: changeQuantityHandler, min: 1, max: 999999, arrows: true, ref: quantityInputRef })),
            item.manuallyAdded ? (!isBOMEditMode && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { "data-testid": "bom-item-quantity", className: BOMItem_scss_1.default.itemQuantity }, item.quantity),
                react_1.default.createElement(PriceTooltip_1.default, { price: item.price, unitOfMeasurement: item.unitOfMeasurement || '' })))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { "data-testid": "bom-item-quantity", className: BOMItem_scss_1.default.itemQuantity }, item.quantity),
                react_1.default.createElement(PriceTooltip_1.default, { price: item.price, unitOfMeasurement: item.unitOfMeasurement || '' }))),
            react_1.default.createElement(BOMItemPrice_1.default, { price: item.sum || 0, discountedPrice: item.discountedSum }),
            react_1.default.createElement(BOMItemNotesButton_1.default, { notesShown: showNotes, onClick: openNotesMenu, isNotesPresent: () => !!item.notes, disabled: isBOMLoading }),
            showNotes && (react_1.default.createElement(BOMItemNotes_1.default, { show: showNotes, notes: item.notes, updateNotesHandler: updateNotesHandler, updateShow: setShowNotes, y: notesWidgetY }))),
        item.services && item.services.length > 0 && (isExpanded || forceExpand) && (0, typeUtils_1.HasDefinedProperty)(item, 'uuid') && (react_1.default.createElement(BOMItemServices_1.default, { services: item.services, isImperialMeasurement: isImperialMeasurement, projectItem: item, manuallyAdded: item.manuallyAdded, parentLineItemNumber: lineItemNumber }))));
}
exports.default = BOMItem;
